import useSWR from "swr";

export const useFetchAdvertisingExpenses = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `ifrea_analytics/restaurants/${restaurantId}/advertising-expenses/` : null;
  const { data: advertisingExpenses, isLoading } = useSWR<number>(fetcherKey)
  return { advertisingExpenses, isLoading };
};